import GChart from "../components/GChart";
import GCharts from "../components/GCharts";
import GoogleCharts from "../components/GoogleCharts";
import LogDataChart from "../components/LogDataChart";
import PostIdPage from "../components/PostIdPage";
import StatusDisplay from "../components/StatusDisplay";
// import VariableTable from "../components/VariableTable";
import About from "../pages/About";
import PageNotFound from "../pages/PageNotFound";
import Posts from "../pages/Posts";
import Schema from "../pages/Schema";
import Fit from "../pages/Fit";

export const privateRoutes = [
    {path: '/', component: Schema, exact: true},
    {path: '/fit', component: Fit, exact: true},
    // {path: '/testgchart', component: GChart, exact: true},
    // {path: '/gchart', component: GCharts, exact: true},
    // {path: '/chart', component: LogDataChart, exact: true},
    // {path: '/google', component: GoogleCharts, exact: true},
    // {path: '/vars', component: VariableTable, exact: true},
    {path: '/status', component: StatusDisplay, exact: true},
    // {path: '/about', component: About, exact: true},
    // {path: '/posts', component: Posts, exact: true},
    // {path: '/posts/:id', component: PostIdPage, exact: true},
    // {path: '/page404', component: PageNotFound, exact: true},
]